// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__14kk8","messages":"Chat_messages__2P4s9","dateDivider":"Chat_dateDivider__2IBvc"};